document.addEventListener("DOMContentLoaded", function() {
  document.addEventListener("pointerdown", function(e){
    if(e.target && e.target.classList.contains('pre-stock-more')) {
      e.preventDefault();
      const detalhes = e.target.closest('.pre-stock-aviso-frontend').nextElementSibling;
      detalhes.classList.toggle('active');
    }
  });
});